const browserLocation =
  typeof window !== "undefined" && window.location ? window.location : null;

const frontendBaseUrl = browserLocation
  ? browserLocation.origin
  : "http://localhost";

module.exports = {
  API_LOCATION: `${frontendBaseUrl}/api`,
  THUMBNAIL_LOCATION: `${frontendBaseUrl}/thumbnails`,
};
